import { FileQuestion, Upload } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useQuotationDraftStore } from '../../store/quotationDraftStore';

interface ReviewUnavailableStateProps {
  fileName: string | null;
}

export function ReviewUnavailableState({ fileName }: ReviewUnavailableStateProps) {
  const setReviewMode = useQuotationDraftStore((s) => s.setReviewMode);
  const showIntake = useQuotationDraftStore((s) => s.showIntake);

  const handleReupload = () => {
    setReviewMode(false);
    showIntake();
  };

  return (
    <div className="flex h-full w-full items-center justify-center bg-muted/30 p-6">
      <div className="max-w-md rounded-md border border-dashed bg-background p-8 text-center">
        <FileQuestion className="mx-auto h-10 w-10 text-muted-foreground/60" />
        <h3 className="mt-3 text-sm font-medium">Source not available</h3>
        <p className="mt-1.5 text-xs text-muted-foreground">
          {fileName
            ? `The original file ${fileName} is no longer available in this session.`
            : 'No source document is available for this draft.'}
          {' '}
          Re-upload from Intake to preview it again.
        </p>
        <Button variant="outline" size="sm" className="mt-4" onClick={handleReupload}>
          <Upload className="h-3.5 w-3.5 mr-1.5" />
          Re-upload from Intake
        </Button>
      </div>
    </div>
  );
}
